<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-year">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Publicité et durée du protocole</p>
        <p class="no-margin dark-gray text-sm">Informations de signature du protocole</p>
      </div>
    </div>
  </div>

  <div class="p-30">
    <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;" class="mb-30">
      <div>
        <p class="dark-blue no-margin">Année de l'élection CSE <span class="red">*</span></p>
        <div>
          <input type="number" name="election_year" id="election_year" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="electionYear" [min]="minYear" [max]="maxYear" (wheel)="$event.preventDefault()"
            placeholder="YYYY">
        </div>
      </div>

    </div>
  </div>